import { Link } from "react-router-dom";
import { Spinner } from "@/components/ui/Spinner";
import { EmptyState, PageHeader, StatTile } from "@/features/power_projects/components/ui";
import { usePageTitle } from "@/hooks/usePageTitle";
import { useMyLedProjects } from "../hooks";
import { ErrorLine, fmtDate } from "../components/common";

/** „Prowadzone projekty" w panelu firmy — lista projektów ZE powierzonych tej firmie. */
export function ContractorLedProjectsPage() {
  usePageTitle("Prowadzone projekty");
  const { data, isLoading, error } = useMyLedProjects();
  const rows = data ?? [];

  if (isLoading) return <div className="flex h-64 items-center justify-center"><Spinner /></div>;
  if (error) return <div className="p-6"><ErrorLine error={error} /></div>;

  return (
    <div>
      <PageHeader title="Prowadzone projekty" subtitle={`Projekty ZE powierzone Waszej firmie · ${rows.length}`} />
      {rows.length === 0 ? (
        <div className="card"><EmptyState>Żaden projekt ZE nie jest obecnie prowadzony przez Waszą firmę</EmptyState></div>
      ) : (
        <ul className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {rows.map((r) => (
            <li key={r.leadership_id}>
              <Link
                to={`/contractor/projects/${r.leadership_id}`}
                className="card-hover block p-4"
                style={{ borderLeft: "3px solid var(--color-primary)" }}
              >
                <div className="text-base font-bold">{r.name}</div>
                <div className="mt-0.5 font-mono text-[11px] text-[var(--color-text-muted)]">
                  {r.order_number ?? "—"} · przekazano {fmtDate(r.handed_over_at)}
                </div>
                <div className="mt-3 flex flex-wrap items-stretch gap-2">
                  <StatTile label="Działki" value={r.counters.parcels_in_route} hint="w trasie" />
                  <StatTile
                    label="Tytuły"
                    value={`${r.counters.owners_secured}/${r.counters.owners_total}`}
                    tone={r.counters.owners_total > 0 && r.counters.owners_secured === r.counters.owners_total ? "ok" : "default"}
                    hint="pozyskane"
                  />
                  <StatTile
                    label="Kafle"
                    value={`${r.counters.tiles_done}/${r.counters.tiles_total}`}
                    tone={r.counters.tiles_total > 0 && r.counters.tiles_done === r.counters.tiles_total ? "ok" : "default"}
                    hint="zrobione"
                  />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
